// 查看会员信息 （客户交易记录）
<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>交易记录明细</h3>
            </div>
            <div class="card-button">
              <el-button class="push-button" @click="NvagetToLookMenber" icon="iconfont icon-fanhui">返回</el-button>
            </div>
          </div>
          <div class="NumberTable">
            <el-form label-width="140px" :model="queryInfo" size="small">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="会员卡号">
                    <el-input v-model="queryInfo.cardNo" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="单据号">
                    <el-input v-model="queryInfo.saleNo" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="门店">
                    <el-input v-model="queryInfo.shopCode" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="相关单据号">
                    <el-input v-model="queryInfo.bindSheetNo" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="币种">
                    <el-input v-model="queryInfo.currencyID" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="实付金额">
                    <el-input v-model="queryInfo.realAmount" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="GIADA Friend姓名">
                    <el-input v-model="queryInfo.gfName" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="不计入升级累计">
                    <el-checkbox v-model="queryInfo.vIPInvalidSale" disabled></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="会员姓名">
                    <el-input v-model="queryInfo.custName" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="交易日期">
                    <el-input v-model="queryInfo.saleDate" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="单据类型">
                    <el-input v-model="queryInfo.saleType" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="业务类型">
                    <el-input v-model="queryInfo.bussKind" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="总单金额">
                    <el-input v-model="queryInfo.sheetAmount" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="出单人">
                    <el-input v-model="queryInfo.saleEmpCode" disabled style="width: 80%"></el-input>
                  </el-form-item>
                  <el-form-item label="GIADA Friend编号">
                    <el-input v-model="queryInfo.gFCode" disabled style="width: 80%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-table
              size="small"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
                fontSize: '14px',
              }"
              :height="'calc(100vh - 42rem)'"
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable"
              :data="list.tbody"
              tooltip-effect="dark"
              v-el-table-infinite-scroll="load"
              v-loading="paging.Loading"
              infinite-scroll-disabled="onLoading"
            >
              <el-table-column type="index" width="80"></el-table-column>
              <el-table-column label="SKU" prop="sku">
                <template slot-scope="scope">
                  <el-link type="primary" @click="jumpRecordTransactions(scope.row.sku)">{{ scope.row.sku }}</el-link>
                </template>
              </el-table-column>
              <el-table-column v-for="(item, index) in list.thead" :label="item.label" :prop="item.prop" :key="index"> </el-table-column>
            </el-table>
            <el-alert v-if="isMore" title="没有更多啦!" type="warning" center show-icon :closable="false"></el-alert>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { queryOrderDetailApi } from "@/api/viewMemberModule";
export default {
  name: "centre",
  data() {
    return {
      paging: {
        pageNum: 1,
        pageSize: 50,
        Loading: false,
      },
      judge: "",
      queryInfo: {
        cardNo: "",
        custName: "",
        saleNo: "",
        saleDate: "",
        shopCode: "",
        saleType: "",
        bussKind: "",
        bindSheetNo: "",
        currencyID: "",
        sheetAmount: "",
        realAmount: "",
        saleEmpCode: "",
        gfName: "",
        gFCode: "",
      },
      list: {
        thead: [
          //设置表头
          {
            label: "产品Barcode",
            prop: "barCode",
          },
          {
            label: "商品状态",
            prop: "itemStatus",
          },
          {
            label: "产品单价",
            prop: "price",
          },
          {
            label: "产品销售折扣",
            prop: "discount",
          },
          {
            label: "产品数量",
            prop: "qty",
          },
          {
            label: "产品总价",
            prop: "shopName",
          },
          {
            label: "原销售单",
            prop: "origSaleNr",
          },
          {
            label: "产品实际成交折扣",
            prop: "realDiscount",
          },
          {
            label: "实售金额",
            prop: "realAmt",
          },
        ],
        tbody: [], // 表格内容
      },
    };
  },
  created() {
    // 列表数据
    this.getInfo();
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
    isMore() {
      return this.judge;
    },
    onLoading() {
      return this.paging.Loading || this.isMore;
    },
  },
  methods: {
    //跳转会员交易记录明细
    jumpRecordTransactions(value) {
      this.$router.push({
        path: "/ProductDetails",
        query: { sku: value },
      });
    },
    getInfo() {
      this.paging.Loading = true;
      let data = require("qs").stringify({
        saleID: localStorage.getItem("saleID"),
        custID: this.custID,
        pageSize: this.paging.pageSize,
        pageNo: this.paging.pageNum,
      });
      queryOrderDetailApi(data)
        .then((res) => {
          res.saleitems.forEach((item) => {
            item.itemStatus = item.itemStatus === 0 ? "正常销售" : item.itemStatus === 1 ? "已被退货" : "已被换货";
          });
          res.data.saleDate = this.renderTime(res.data.saleDate).substring(0, 16);
          res.data.bussKind = res.data.bussKind === 0 ? "销售单" : "预购单";
          res.data.saleType = this.saleFilter(res.data.saleType);
          this.queryInfo = res.data;
          res.saleitems.length < 50 ? (this.judge = true) : (this.judge = false);
          this.list.tbody = res.saleitems;
        })
        .finally(() => {
          this.paging.Loading = false;
          console.log(this.paging, "this.paging");
        });
    },
    load() {
      this.paging.Loading = true;
      setTimeout(() => {
        this.paging.pageSize += 50;
        this.getInfo();
      }, 1000);
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //单据类型筛选
    saleFilter(value) {
      let result;
      switch (value) {
        case 0:
          result = "销售";
          break;
        case 1:
          result = "换货";
          break;
        case 2:
          result = "退货";
          break;
        case 3:
          result = "预购单提货";
          break;
        case 10:
          result = "预购";
          break;
        case 11:
          result = "预购撤单";
          break;
      }
      return result;
    },
    TouchTheBottom() {
      this.paging.page++;
      this.getInfo();
    },
    NvagetToLookMenber() {
      this.$router.push("/Transactions");
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 20px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
